import { Link } from '@tanstack/react-router'
import type { ReactNode } from 'react'

import { cn } from '@/_lib/utils'

export interface TabNavItem {
  label: string
  href: string
  isActive: boolean
  hidden?: boolean
  badge?: ReactNode
}

export interface TabNavProps {
  items: TabNavItem[]
}

export function TabNav({ items }: TabNavProps) {
  return (
    <nav className="flex gap-6 border-b border-brand-grayscale-4">
      {items
        .filter((item) => !item.hidden)
        .map((item) => (
          <Link
            key={item.label}
            to={item.href}
            preload="intent"
            className={cn(
              '-mb-px inline-flex items-center gap-1.5 border-b-2 pb-2 text-sm transition-colors',
              item.isActive
                ? 'border-foreground font-medium text-foreground'
                : 'border-transparent text-muted-foreground hover:text-foreground',
            )}
          >
            {item.label}
            {item.badge}
          </Link>
        ))}
    </nav>
  )
}
